import { Alert, IconButton, Snackbar } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import pm from "@/core/helpers/ProcessManager";
import { ReactNode } from 'react';


export interface PopupSnackBarProps {
    open?: boolean;
    severity?: "error" | "warning" | "success" | "info"
    message?: string | null | ReactNode;
    location?: {
        vertical: "top" | "bottom";
        horizontal: "left" | "center" | "right";
    };
    autoHideDuration?: number;
    onClose?: () => void;
}

export default function PopupSnackBar(props: PopupSnackBarProps) {
    const {
        open,
        message,
        severity,
        location: snackBarLocation,
        autoHideDuration,
        onClose,
    } = props;

    const action = (
        <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={pm.closeSnackBar}
        >
            asd
            <CloseIcon fontSize="small" />
        </IconButton>
    );

    const renderMessage = (msg: any) => {
        // 1. Если это примитив (строка или число) — выводим как есть
        if (typeof msg === 'string' || typeof msg === 'number') {
            return msg;
        }

        // 2. Если это валидный React-элемент (например, <span> или компонент)
        // Мы проверяем через isValidElement, чтобы не пытаться рендерить обычные JS-объекты
        if (require('react').isValidElement(msg)) {
            return msg;
        }

        // 3. Если пришел объект ошибки (Error), выводим его сообщение
        if (msg instanceof Error) {
            return msg.message;
        }

        // 4. Если это непонятный объект, превращаем его в строку (или возвращаем null)
        // Это предотвратит падение сайта
        return null;
    };

    return (
        <Snackbar
            sx={{
                zIndex: (theme) => theme.zIndex.modal + 1000
            }}
            anchorOrigin={{
                vertical: snackBarLocation?.vertical ?? "top",
                horizontal: snackBarLocation?.horizontal ?? "right",
            }}
            open={open && !!message}
            autoHideDuration={autoHideDuration || 6000}
            action={action}
            onClose={onClose}
        >
            <Alert onClose={onClose} severity={severity} sx={{ width: '100%' }}>
                {renderMessage(message)}
            </Alert>
        </Snackbar>
    );
}
